// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface SupportUser
 */
export interface SupportUser {
    /**
     * User Id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportUser
     */
    userId?: string;
    /**
     * Account Id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportUser
     */
    accountId?: string;
    /**
     * First name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportUser
     */
    first?: string;
    /**
     * Last name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportUser
     */
    last?: string;
    /**
     * Email Address
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportUser
     */
    email?: string;
    /**
     * Phone Number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportUser
     */
    phone?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportUser
     */
    created?: string;
}

export function SupportUserFromJSON(json: any): SupportUser {
    return {
            'userId': !exists(json, 'userId') ? undefined : json['userId'],
            'accountId': !exists(json, 'accountId') ? undefined : json['accountId'],
            'first': !exists(json, 'first') ? undefined : json['first'],
            'last': !exists(json, 'last') ? undefined : json['last'],
            'email': !exists(json, 'email') ? undefined : json['email'],
            'phone': !exists(json, 'phone') ? undefined : json['phone'],
            'created': !exists(json, 'created') ? undefined : json['created'],
    };

}

export function SupportUserToForm(value?: SupportUser): any {
    let jsonVal = SupportUserToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportUserToJSON(value?: SupportUser): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'userId': cleanupBlankValuesForBackend(value.userId),
            'accountId': cleanupBlankValuesForBackend(value.accountId),
            'first': cleanupBlankValuesForBackend(value.first),
            'last': cleanupBlankValuesForBackend(value.last),
            'email': cleanupBlankValuesForBackend(value.email),
            'phone': cleanupBlankValuesForBackend(value.phone),
            'created': cleanupBlankValuesForBackend(value.created),
    };
}


